// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"styles_buttonWrapper__3UiJ6","noReports":"styles_noReports__3_Gqc","error":"styles_error__1tc15"};